/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - quotation.njk
 *   - quotation.css
 */

export const QUOTATION_TEMPLATE = `<div class="qt-card">
  <!-- Top Accent Border/Bar -->
  <div class="qt-accent"></div>

  <!-- Header -->
  <div class="qt-hdr">
    <div class="qt-hdr-left">
      <div class="qt-store-name">{{ storeName }}</div>
      <div class="qt-store-info">
        {% if address %}{{ address | replace('\\n', '<br/>') | safe }}{% endif %}
        {% if phone %}<br/>Tel: {{ phone }}{% endif %}
      </div>
    </div>
    <div class="qt-hdr-right">
      <div class="qt-doc-label">Quotation</div>
      <div class="qt-doc-number">{{ refNo }}</div>
      <div class="qt-doc-date">Date: {{ dateStr }}</div>
    </div>
  </div>

  <!-- Re/Subject line if quotationName is present and is not just the default ID -->
  {% if quotationName and not quotationName.startsWith('Quotation #') %}
  <div class="qt-subject">
    <span class="qt-subject-label">Subject:</span>
    <span class="qt-subject-value">{{ quotationName }}</span>
  </div>
  {% endif %}

  <!-- Meta Grid (Quoted To & Info) -->
  <div class="qt-meta-grid">
    <div class="qt-meta-block">
      <div class="qt-meta-title">Prepared For</div>
      <div class="qt-customer-name">
        {{ customerName }}
        {% if not isRegistered %}
          <span class="qt-temp-badge">Temporary</span>
        {% endif %}
      </div>
      <div class="qt-customer-details">
        {% if customerAddress %}<div class="qt-detail-line">{{ customerAddress }}</div>{% endif %}
        {% if customerPhone %}<div class="qt-detail-line"><strong>Tel:</strong> {{ customerPhone }}</div>{% endif %}
        {% if customerEmail %}<div class="qt-detail-line"><strong>Email:</strong> {{ customerEmail }}</div>{% endif %}
      </div>
    </div>
    
    <div class="qt-meta-block qt-meta-right">
      <div class="qt-meta-title">Quotation Details</div>
      <div class="qt-details-grid">
        <div class="qt-detail-row">
          <span class="lbl">Quote No:</span>
          <span class="val">{{ refNo }}</span>
        </div>
        <div class="qt-detail-row">
          <span class="lbl">Date:</span>
          <span class="val">{{ dateStr }}</span>
        </div>
        <div class="qt-detail-row">
          <span class="lbl">Validity:</span>
          <span class="val">{{ validityDays }} Days</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Body -->
  <div class="qt-body">
    <!-- Items Table -->
    <table class="qt-table">
      <thead>
        <tr>
          <th align="left" style="width: 5%">#</th>
          <th align="left">Description</th>
          <th align="center" style="width: 10%">Qty</th>
          <th align="right" style="width: 20%">Unit Price</th>
          <th align="right" style="width: 20%">Total</th>
        </tr>
      </thead>
      <tbody>
        {% for item in items %}
        <tr>
          <td align="left" class="qt-td-num">{{ loop.index }}</td>
          <td>
            <div class="qt-td-name">{{ item.name }}</div>
            {% if item.batch_no %}<div class="qt-td-batch">Batch: {{ item.batch_no }}</div>{% endif %}
          </td>
          <td align="center" class="qt-td-qty">{{ item.qty }}</td>
          <td align="right">{{ currency }} {{ item.price | formatPrice }}</td>
          <td align="right" class="qt-td-total">{{ currency }} {{ (item.price * item.qty) | formatPrice }}</td>
        </tr>
        {% endfor %}
      </tbody>
    </table>

    <!-- Summary Row -->
    <div class="qt-summary-container">
      <div class="qt-notes-col">
        <div class="qt-validity-card">
          <div class="qt-validity-title">Terms & Conditions</div>
          <p>This quotation is valid for {{ validityDays }} days from the date of issue. Prices are subject to change after the validity period.</p>
        </div>
      </div>
      <div class="qt-totals-col">
        <div class="qt-total-row">
          <span class="lbl">Subtotal</span>
          <span class="val">{{ currency }} {{ subtotal | formatPrice }}</span>
        </div>
        <div class="qt-total-row grand-total">
          <span class="lbl">Grand Total</span>
          <span class="val">{{ currency }} {{ subtotal | formatPrice }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Signatures Block -->
  <div class="qt-signature-section">
    <div class="qt-signature-block">
      <div class="qt-sig-line"></div>
      <p>Prepared By</p>
    </div>
    <div class="qt-signature-block">
      <div class="qt-sig-line"></div>
      <p>Accepted By (Customer Signature)</p>
    </div>
  </div>

  <!-- Footer -->
  <div class="qt-ftr">
    <p class="qt-ftr-msg">{{ footer }}</p>
    <p class="powered">Powered by TaproDev POS</p>
  </div>
</div>
`;

export const QUOTATION_CSS = `@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap");

*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  font-size: var(--qt-font, 13.5px);
  color: #1e293b;
  background: var(--qt-bg, #edf2f7);
  padding: var(--qt-body-pad, 28px 20px);
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.qt-card {
  width: var(--qt-width, 210mm);
  max-width: 100%;
  margin: 0 auto;
  background: #ffffff;
  border-radius: var(--qt-radius, 6px);
  overflow: hidden;
  box-shadow: var(--qt-shadow, 0 1px 3px rgba(15, 23, 42, 0.08));
  border: var(--qt-card-border, 1px solid #cbd5e1);
}

.qt-accent {
  height: 4px;
  background: #0f172a; /* Deep elegant charcoal black accent bar instead of indigo */
}

/* Header */
.qt-hdr {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  padding: 32px 40px 24px;
  border-bottom: 1px solid #cbd5e1;
  flex-wrap: wrap;
}

.qt-store-name {
  font-size: 1.6em;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.03em;
  line-height: 1.15;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.qt-store-info {
  font-size: 0.85em;
  color: #475569;
  line-height: 1.6;
}

.qt-hdr-right {
  text-align: right;
  flex-shrink: 0;
}

.qt-doc-label {
  font-size: 1.8em;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #0f172a;
  line-height: 1;
  margin-bottom: 8px;
}

.qt-doc-number {
  font-size: 1.1em;
  font-weight: 600;
  color: #475569;
  letter-spacing: 0.02em;
  font-variant-numeric: tabular-nums;
}

.qt-doc-date {
  font-size: 0.85em;
  color: #64748b;
  margin-top: 6px;
}

/* Re: Subject Banner */
.qt-subject {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  border-left: 4px solid #475569;
  padding: 12px 40px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.qt-subject-label {
  font-size: 0.75em;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #64748b;
  flex-shrink: 0;
}

.qt-subject-value {
  font-size: 0.95em;
  font-weight: 600;
  color: #1e293b;
}

/* Meta Section */
.qt-meta-grid {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  padding: 24px 40px;
  border-bottom: 1px solid #e2e8f0;
}

.qt-meta-block {
  flex: 1;
  min-width: 200px;
}

.qt-meta-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.qt-meta-title {
  font-size: 0.7em;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin-bottom: 8px;
}

.qt-customer-name {
  font-size: 1.15em;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.qt-temp-badge {
  display: inline-block;
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  font-size: 0.65em;
  font-weight: 700;
  padding: 1px 6px;
  margin-left: 6px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  vertical-align: middle;
}

.qt-customer-details {
  font-size: 0.88em;
  color: #334155;
  line-height: 1.6;
}

.qt-customer-details strong {
  color: #475569;
}

.qt-details-grid {
  width: 240px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.qt-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.88em;
  padding-bottom: 4px;
  border-bottom: 1px dashed #f1f5f9;
}

.qt-detail-row:last-child {
  border-bottom: none;
}

.qt-detail-row .lbl {
  color: #64748b;
  font-weight: 500;
}

.qt-detail-row .val {
  color: #0f172a;
  font-weight: 600;
  text-align: right;
}

/* Body / Table */
.qt-body {
  padding: 24px 40px;
}

.qt-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 24px;
  font-size: 0.9em;
}

.qt-table thead th {
  padding: 10px 14px;
  color: #0f172a;
  background: #f8fafc;
  font-weight: 700;
  font-size: 0.75em;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  border-top: 1px solid #cbd5e1;
  border-bottom: 2px solid #0f172a;
}

.qt-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
}

.qt-table tbody tr:last-of-type {
  border-bottom: 1px solid #cbd5e1;
}

.qt-table tbody td {
  padding: 12px 14px;
  color: #334155;
  vertical-align: top;
}

.qt-td-num {
  color: #94a3b8;
  font-weight: 500;
}

.qt-td-name {
  font-weight: 600;
  color: #0f172a;
}

.qt-td-batch {
  font-size: 0.8em;
  color: #64748b;
  margin-top: 3px;
}

.qt-td-qty {
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.qt-td-total {
  font-weight: 600;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

/* Summary Grid */
.qt-summary-container {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  margin-top: 24px;
  flex-wrap: wrap;
}

.qt-notes-col {
  flex: 1;
  min-width: 280px;
}

.qt-totals-col {
  width: 320px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.qt-validity-card {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 16px 20px;
  font-size: 0.82em;
  color: #475569;
  line-height: 1.6;
}

.qt-validity-title {
  font-weight: 700;
  color: #0f172a;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 6px;
  font-size: 0.8em;
}

.qt-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  font-size: 0.9em;
  color: #475569;
}

.qt-total-row .lbl {
  font-weight: 500;
}

.qt-total-row .val {
  font-weight: 600;
  color: #0f172a;
}

.qt-total-row.grand-total {
  border-top: 1.5px solid #0f172a;
  border-bottom: 3px double #0f172a;
  padding: 10px 12px;
  font-size: 1.1em;
  font-weight: 700;
  color: #0f172a;
  background: #f8fafc;
}

.qt-total-row.grand-total .lbl {
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.qt-total-row.grand-total .val {
  font-weight: 800;
  font-size: 1.05em;
}

/* Signatures Section */
.qt-signature-section {
  display: flex;
  justify-content: space-between;
  margin-top: 56px;
  padding: 0 40px;
  gap: 40px;
  flex-wrap: wrap;
}

.qt-signature-block {
  flex: 1;
  min-width: 200px;
  text-align: center;
}

.qt-sig-line {
  border-bottom: 1.5px solid #cbd5e1;
  margin-bottom: 10px;
  height: 48px;
}

.qt-signature-block p {
  font-size: 0.78em;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

/* Footer */
.qt-ftr {
  text-align: center;
  padding: 24px 40px;
  background: #f8fafc;
  border-top: 1px solid #cbd5e1;
  margin-top: 48px;
}

.qt-ftr-msg {
  font-size: 0.85em;
  color: #475569;
  line-height: 1.6;
}

.qt-ftr .powered {
  font-size: 0.7em;
  color: #94a3b8;
  margin-top: 8px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

/* Print Overrides */
@media print {
  body {
    background: #ffffff;
    padding: 0;
  }
  .qt-card {
    box-shadow: none;
    border: none;
    border-radius: 0;
    width: 100% !important;
  }
  @page {
    size: var(--qt-page-size, A4);
    margin: 0;
  }
}`;
